import { useState, useEffect, useMemo } from 'react';
import _debounce from 'lodash/debounce';

export default () => {
  const forceUpdate = useState()[1];
  const debounceFn = useMemo(() => _debounce(forceUpdate, 500), [forceUpdate]);
  useEffect(() => {
    window.addEventListener('resize', debounceFn);
    return () => {
      window.removeEventListener('resize', debounceFn);
    };
  }, [debounceFn]);
};



// WEBPACK FOOTER //
// ./src/lib/hooks/useForceUpdateOnWindowResize.js